export default {
  login: '/login',
  update: (id: string) => `/users/${id}`,
  updateFile: (id: string) => `/users/updatePath/${id}`,
  testBusiness: (email: string) => `/credit/testBusinessReport?email=${email}`,
  testConsumer: (email: string) => `/credit/testConsumerReport?email=${email}`,
  getUsers: '/users',
};
